import { render, staticRenderFns } from "./discountCoupon.vue?vue&type=template&id=08c0dae2&scoped=true"
import script from "./discountCoupon.vue?vue&type=script&lang=js"
export * from "./discountCoupon.vue?vue&type=script&lang=js"
import style0 from "./discountCoupon.vue?vue&type=style&index=0&id=08c0dae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c0dae2",
  null
  
)

export default component.exports